// extracted by mini-css-extract-plugin
export default {"component":"ExactDuplicatesLayout_component__GuvHs"};